// Where the API is. The app is served on the API's own origin (no CORS, no cookies), so the
// default is this page's origin; a build for another host sets VITE_ARTISAN_API_URL.
const configured = (import.meta.env.VITE_ARTISAN_API_URL as string | undefined)?.replace(/\/$/, "");

export function apiBase(): string {
  return configured || window.location.origin;
}

export function apiUrl(path: string): string {
  return `${apiBase()}${path}`;
}

export const appBase = import.meta.env.BASE_URL;

/** The web app (sign-up, password reset, invitations) that belongs to this API host:
 * api.artisan.mn -> app.artisan.mn, staging.artisan.mn -> app-staging.artisan.mn. Null for
 * any other host (development, a test server), where the links are left out. */
export function webUrl(path: string, host = window.location.host): string | null {
  const m = /^(api|staging)\.(artisan\.mn)$/.exec(host);
  if (!m) return null;
  return `https://${m[1] === "api" ? "app" : "app-staging"}.${m[2]}${path}`;
}
